import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import ModuleHeader from "./ModuleHeader";
import ReactEcharts from "echarts-for-react";
import { lcgApi } from "@/api/lcgApi";
import { REM_CONFIG } from "@/utils/fontSize";
const ReceiveAndSend = ({ className = "" }) => {
    const chartRef = useRef(null);
    const [chartData, setChartData] = useState([]);
    const months = chartData.map((item) => item.month) || [];
    const initialData = chartData.map((item) => item.beginningInventory) || [];
    const finalData = chartData.map((item) => item.endingInventory) || [];
    useEffect(() => {
        getData();
    }, []);
    /**
     * @description: getData - 获取数据
     */
    const getData = async () => {
        try {
            const res = await lcgApi.monthStats();
            setChartData(res.data);
        }
        catch (error) {
            console.error("获取部门数据失败:", error);
            // 可以设置默认数据或错误处理
        }
    };
    // ECharts 配置项（还原设计稿：平滑曲线 + 标记点 + 深色主题）
    const option = {
        // 全局颜色（匹配设计稿的“期初-蓝”“期末-青”）
        color: ["#4DA6FF", "#00E6F0"],
        xAxis: {
            type: "category",
            data: months,
            axisLabel: {
                color: "#fff",
                fontSize: REM_CONFIG.fontSize.small,
                interval: 0,
                formatter: (name) => {
                    return name.split("-")[1] + "月";
                },
            },
            axisLine: {
                lineStyle: { color: "#446b9f" },
            },
            axisTick: { show: false },
            boundaryGap: false, // 让折线从坐标轴起点开始
        },
        yAxis: {
            type: "value",
            axisLabel: {
                color: "#fff",
                fontSize: REM_CONFIG.fontSize.small,
            },
            name: "数量（项）",
            nameTextStyle: {
                color: "#fff",
                fontSize: REM_CONFIG.fontSize.small,
            },
            axisLine: {
                lineStyle: { color: "#446b9f" },
            },
            splitLine: {
                lineStyle: {
                    color: "rgba(200, 223, 255, 0.1)", // 浅灰虚线，贴合背景
                    type: "dashed",
                },
            },
            min: 0,
            max: 100, // 固定值域，匹配设计稿刻度
        },
        series: [
            {
                name: "期初",
                type: "line",
                data: initialData,
                smooth: true, // 平滑曲线，还原设计稿的流畅感
                lineStyle: {
                    width: 2, // 线条粗细
                },
                symbol: "circle", // 标记点（实心圆）
                symbolSize: 8,
                itemStyle: {
                    borderColor: "#0F2E56", // 深色边框，增强立体感
                    borderWidth: 2,
                },
            },
            {
                name: "期末",
                type: "line",
                data: finalData,
                smooth: true,
                lineStyle: {
                    width: 2,
                },
                symbol: "circle",
                symbolSize: 8,
                itemStyle: {
                    borderColor: "#0F2E56",
                    borderWidth: 2,
                },
            },
        ],
        legend: {
            data: ["期初", "期末"],
            textStyle: {
                color: "#fff",
                fontSize: REM_CONFIG.fontSize.small,
            },
            right: "center",
            top: 10, // 图例居右上角
        },
        grid: {
            left: "6%",
            right: "8%",
            bottom: "10%",
            top: 40, // 紧凑布局，适配无表格场景
            containLabel: true,
        },
        tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(7, 31, 75, 0.8)", // 半透明背景
            borderColor: "#446b9f",
            textStyle: { color: "#fff" },
            axisPointer: {
                type: "line",
                lineStyle: { color: "rgba(200, 223, 255, 0.3)" }, // 浅灰辅助线
            },
        },
    };
    return (_jsxs("div", { className: `
        relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
        flex flex-col 
        ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u6536\u53D1\u7ED3\u5B58" }), _jsx("div", { className: "flex-1", style: { minHeight: 0 }, children: _jsx(ReactEcharts, { ref: chartRef, option: option, style: { width: "100%", height: "100%" } }) })] }));
};
export default ReceiveAndSend;
